import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	computed,
	CUSTOM_ELEMENTS_SCHEMA,
	ElementRef,
	Inject,
	input,
	PLATFORM_ID,
	viewChild,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DescriptionComponent } from '@uc/shared/ui';
import { RouterLink } from '@angular/router';
import { CoursesHubLink } from '../../models/course-degree-hub.models';
import { Environment } from '@uc/utilities';

@Component({
	selector: 'uc-courses-hub-links',
	templateUrl: './courses-hub-links.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [DescriptionComponent, RouterLink, CommonModule],
})
export class CoursesHubLinksComponent implements AfterViewInit {
	sectionTitle = input.required<string>();
	description = input.required<string>();
	links = input.required<CoursesHubLink[]>();

	groupedLinks = computed(() => this._groupLinks());

	clearingCopy = 'No courses available until 5th July';
	clearingEnabled!: boolean;

	protected swiperRef = viewChild.required<ElementRef>('swiperRef');

	constructor(
		@Inject('environment') private _environment: Environment,
		@Inject(PLATFORM_ID) private _platformId: object,
	) {
		this.clearingEnabled = this._environment.clearingEnabled;
	}

	ngAfterViewInit(): void {
		if (isPlatformBrowser(this._platformId)) {
			this._initSwiper();
		}
	}

	private _initSwiper() {
		const config = {
			slidesPerView: 1.4,
			spaceBetween: 10,
			loop: false,
			noSwipingClass: 'swiper-no-swiping',
			breakpoints: {
				768: {
					slidesPerView: 4,
					spaceBetween: 20,
					slidesPerGroup: 4,
				},
			},
		};

		const swiperEl = this.swiperRef()?.nativeElement;
		Object.assign(swiperEl, config);

		swiperEl?.initialize();
	}

	private _groupLinks() {
		const linksGrouped = [];
		for (let i = 0; i < this.links().length; i += 3) {
			linksGrouped.push(this.links().slice(i, i + 3));
		}

		return linksGrouped;
	}
}
